module.exports = __webpack_public_path__ + "static/glorious_1-50b245d9b2de44e2867071cb05e2d903.jpg";